// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-block-item[data-v-cb4431f8]{margin:40px 0}@media only screen and (min-width:960px){.content-block-item[data-v-cb4431f8]{margin:120px 0}}.pre[data-v-cb4431f8]{white-space:pre-wrap;word-break:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
